// extracted by mini-css-extract-plugin
module.exports = {"jds-LayoutColumn":"layouColumn_jds-LayoutColumn__QufQy","jds-LayoutColumn--fixedWidth":"layouColumn_jds-LayoutColumn--fixedWidth__JCI_8"};